import React, { Component } from "react";
import styled from "styled-components";

const IconTip = styled.div`
  position: absolute;
  bottom: 34px;
  left: -24px;
  width: auto;
  white-space: nowrap;
  padding: ${props => props.small ? 10 : 23}px;
  font-family: Tahoma, sans-serif;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1;
  color: #717171;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 0 1.5px rgb(207, 207, 207), 0 3px 8px rgba(0, 0, 0, .25);
  z-index: 100;
  :after {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: -12px;
    left: 21.5px;
    background-color: transparent;
    border: 11px solid transparent;
    border-top: 12px solid #fff;
    border-bottom: none;
  }
  :before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: -14px;
    left: 19px;
    background-color: transparent;
    border: 14px solid transparent;
    border-top: 14px solid rgb(207, 207, 207);
    border-bottom: none;
  }
`;

export default class Tooltipy extends Component {
  state = {
    showTooltip: false
  };

  onHover = () => {
    this.setState({
      showTooltip: true
    });
  };

  onUnhover = () => {
    this.setState({
      showTooltip: false
    });
  };

  render() {
    const { tooltip, small, children } = this.props;

    return (
      <span>
        {this.state.showTooltip &&
          <IconTip small={small}>
            {tooltip}
          </IconTip>}

        <span onMouseOver={this.onHover} onMouseLeave={this.onUnhover}>
          {children}
        </span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tooltipy.js